import { Fragment, useCallback } from "react";
import "./MedicationStatement.css";
import { useState } from "react";

const MedicationStatement = (props) => {
  const [data, setData] = useState(props.getData());
  const [currentIdx, setcurrentIdx] = useState("");

  const [searchText, setSearchText] = useState("");

  const handleChange = useCallback(
    (e) => {
      setSearchText(e.target.value);
      setcurrentIdx("");
      const originalData = props.getData();
      const filteredData = originalData.objects.filter((item) =>
        item.resource.medicationCodeableConcept.text
          .trim()
          .toLowerCase()
          .includes(e.target.value.trim().toLowerCase())
      );
      setData({ objects: filteredData });
    },
    [props]
  );

  return (
    <div className="observationContainerResource">
      <div className="search">
        <input
          type="text"
          value={searchText}
          onChange={handleChange}
          className="searchBox"
          placeholder="Search..."
        />
      </div>
      {data?.objects?.map((item, index) => (
        <Fragment key={index}>
          {item?.resource?.medicationCodeableConcept && (
            <p
              key={index}
              className={`${
                index === data?.objects?.length - 1 ? "lastRow" : ""
              } ${
                currentIdx === index ? "active" : ""
              } cursor-pointer observationItem`}
              onClick={() => {
                props.setResourceListData(item);
                setcurrentIdx(index);
              }}
            >
              {item?.resource?.medicationCodeableConcept?.text}{" "}
              {item?.resource?.status && item.resource.status === "active" ? (
                <span>Current Medication</span>
              ) : (
                <span>Past Medication</span>
              )}
            </p>
          )}
          {item?.resource?.medicationReference && (
            <p
              key={index}
              className={`${
                index === data?.objects?.length - 1 ? "lastRow" : ""
              } ${currentIdx === index ? "active" : ""} cursor-pointer`}
              onClick={() => {
                props.setResourceListData(item);
                setcurrentIdx(index);
              }}
            >
              {item?.resource?.medicationReference?.display}{" "}
              {item?.resource?.status && item.resource.status === "active" ? (
                <span>Current Medication</span>
              ) : (
                <span>Past Medication</span>
              )}
            </p>
          )}
        </Fragment>
      ))}
    </div>
  );
};

export default MedicationStatement;
